import { Radio } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import WidgetCard from '../common/WidgetCard';

type DataKey = 'agronomist' | 'planting-group';

interface SeasonSummaryWidgetLayoutProps {
  children: React.ReactNode;
  selectedTab: DataKey;
  onSelectedTabChange: React.Dispatch<React.SetStateAction<DataKey>>;
}

const SeasonSummaryWidgetLayout = ({
  children,
  selectedTab,
  onSelectedTabChange,
}: SeasonSummaryWidgetLayoutProps) => {
  const { t } = useTranslation();

  return (
    <WidgetCard
      header={'Season Summary'}
      headerExtraContent={
        <Radio.Group
          onChange={(e) => onSelectedTabChange?.(e.target.value)}
          value={selectedTab}
          style={{ marginBottom: 8 }}
        >
          <Radio.Button value="agronomist">
            {t('seasonOverview.labels.agronomist')}
          </Radio.Button>
          <Radio.Button value="planting-group">
            {t('seasonOverview.labels.plantingGroups')}
          </Radio.Button>
        </Radio.Group>
      }
    >
      {children}
    </WidgetCard>
  );
};

export default SeasonSummaryWidgetLayout;
